import { useState, useEffect, Fragment } from "react"
import withStyles from "react-jss"
import DotPlot from "./DotPlot"
import {
  distribution_annotations,
  ANIM_STATE,
} from "../../data/distribution-chart/annotations"
import {
  SCROLLY_TEXTBOX_OUTER_PADDING,
  SCROLLY_TEXTBOX_INNER_PADDING,
} from "../../data/globalStyles"

const styles = {
  main: {
    position: "relative",
    width: "100%",
    display: "flex",
    maxWidth: "1140px",
    margin: "0 auto",
    padding: 0,
    color: "#ffffff",
    boxSizing: "border-box",
    "@media only screen and (max-width: 840px)": {
      flexDirection: "column",
    },
  },
  right: {
    boxSizing: "border-box",
    position: "relative",
    width: "55%",
    margin: 0,
    "@media only screen and (max-width: 840px)": {
      position: "sticky",
      bottom: 0,
      display: "flex",
      alignItems: "center",
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
      height: "100vh",
    },
  },
  left: {
    boxSizing: "border-box",
    width: "45%",
    zIndex: 2,
    ...SCROLLY_TEXTBOX_OUTER_PADDING,
    "@media only screen and (max-width: 840px)": {
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
      "& > :last-child": {
        margin: "100vh auto 0 auto",
      },
    },
  },
  textContainer: {
    width: "100%",
    maxWidth: "460px",
    boxSizing: "border-box",
    margin: "100vh auto",
    background: "#ffffff",
    borderRadius: "4px",
    ...SCROLLY_TEXTBOX_INNER_PADDING,
  },
  text: {
    fontFamily: "BreveText",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "19px",
    color: "#000000",
    margin: 0,
  },
}

const DistributionChart = ({ classes }) => {
  const [state, setState] = useState("")

  useEffect(() => {
    const items = Array.from(
      document.querySelectorAll("#distribution-chart-textContent div")
    )

    const detectIntersection = (entries) => {
      for (let e of entries) {
        let j = items.indexOf(e.target)
        if (e.isIntersecting) {
          setState(ANIM_STATE[j])
        }
      }
    }

    const options = {
      threshold: 0.25,
    }
    const observer = new IntersectionObserver(detectIntersection, options)
    items.forEach((i) => observer.observe(i))
  }, [])

  return (
    <section className={classes.main}>
      <article id="distribution-chart-textContent" className={classes.left}>
        {distribution_annotations.map((row) =>
          row.content2 ? (
            <div className={classes.textContainer} key={row.id}>
              <p className={classes.text}>{row.content}</p>
              <br />
              <p className={classes.text}>{row.content2}</p>
            </div>
          ) : (
            <div className={classes.textContainer} key={row.id}>
              <p key={row.id} className={classes.text}>
                {row.content}
              </p>
            </div>
          )
        )}
      </article>
      <figure className={classes.right}>
        <DotPlot state={state} />
      </figure>
    </section>
  )
}

export default withStyles(styles)(DistributionChart)
